import { MULTI_VALUE_SELECT_COLORS } from 'utils/constants'

/**
 * A tag/label rendered in its assigned palette color. fb-ui `Badge` only takes
 * the enum palette, while tags carry an arbitrary stored hex, so this mirrors the
 * app's tag pill via inline style. Pass `textColor` when the record supplies one
 * (contact/label tags do); otherwise the paired text color is recovered from
 * MULTI_VALUE_SELECT_COLORS by background, falling back to the first/neutral entry.
 * Shared by the deal + contact detail pages so tags look identical on both.
 */
export function TagPill({
  label,
  color,
  textColor,
}: {
  label: string
  color?: string | null
  textColor?: string | null
}) {
  const fallback = MULTI_VALUE_SELECT_COLORS[0]
  const paletteMatch = color
    ? MULTI_VALUE_SELECT_COLORS.find((c) => c.background === color)
    : undefined
  const background = color ?? fallback.background
  const text = textColor ?? paletteMatch?.text ?? fallback.text
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
      style={{ backgroundColor: background, color: text }}
    >
      {label}
    </span>
  )
}
